<template>
  <el-container class="father">
    <el-header class="layout-header">
      <!-- 顶部蓝色导航栏 -->
      <div class="header-top">
        <div class="header-left">
          <img src="/fonts/logo96320.png" alt />
          <span class="title">湖南省96320转运车管理系统</span>
        </div>
        <div class="header-center">
          <div class="home" v-if="home.length!==0">
            <img src="../../fonts/home@2x.png" alt />
            <span @click="$router.push(home[0].menuUrl)">首页</span>
          </div>
          <div class="operation" v-if="operation.length!==0">
            <img src="../../fonts/operation@2x.png" alt />
            <span @click="$router.push(operation[0].menuUrl)">运营管理</span>
          </div>
          <div class="setting" v-if="system.length!==0">
            <img src="../../fonts/settings@2x.png" alt />
            <span @click="$router.push(system[0].menuUrl)">业务管理</span>
          </div>
        </div>
        <div class="header-right">
          <img src="../../fonts/user@2x.png" alt />
          <span>欢迎&nbsp;{{ userName }}</span>
          <span @click="editUserTap()" class="exit">修改密码</span>
          <span @click="exit()" class="exit">退出登录</span>
        </div>
      </div>

      <!-- 面包屑 + 标签页 + 大屏按钮 区域 -->
      <div class="header-under">
        <i></i>
        <!-- 面包屑 -->
        <el-breadcrumb separator="|" class="breadcrumb-box" style="font-size: 13px;">
          <el-breadcrumb-item>
            <span @click="statusEliminate($route.meta.bread.title)">{{ $route.meta.bread.title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.meta.bread.children">
            {{ $route.meta.bread.children.title }}
          </el-breadcrumb-item>
         <!-- <el-breadcrumb-item v-if="$route.meta.bread.children && $route.meta.bread.children.children">
            {{ $route.meta.bread.children.children.title }}
          </el-breadcrumb-item> -->
        </el-breadcrumb>

        <!-- 标签页（核心优化：加最大宽度限制） -->
        <div class="tags-view-wrapper">
          <TagsView class="tags-view-inline" />
        </div>

        <!-- 大屏按钮 -->
        <el-button v-if="largeScreen.length!==0" type="warning" class="header-under-btn" @click="toBigscreen">
          <span>大屏</span>
        </el-button>
      </div>
    </el-header>

    <el-container class="main">
      <router-view />
    </el-container>

    <el-footer>
      <div class="footer">湖南96320服务平台 Copyright 2013-2026 ©版权所有 湘ICP备2020023409号-1</div>
    </el-footer>

    <el-dialog :visible.sync="editUserFormVisible" class="edit-dialog layout-modify">
      <span slot="title" class="dialog-Title">修改用户密码</span>
      <el-form :model="editUserForm" inline ref="editForms" :rules="editRules">
        <el-row>
          <el-form-item label="用户名">
            <el-input v-model="editUserForm.userName" autocomplete="off" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="editUserForm.mobilePhone" autocomplete="off" :disabled="disabled"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="passWord1" label="新密码">
            <el-input type="password" v-model="editUserForm.passWord1" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="passWord2" label="确认新密码">
            <el-input type="password" v-model="editUserForm.passWord2" autocomplete="off"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="editUserFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserPassWd('editForms')">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { handleSpeak, IsPhone } from '@/utils/speechSynthesis.js'
import TagsView from '@/components/TagsView/index.vue' // 

var validatePass = (rule, value, callback) => {
  // 必须包含⼤⼩写字母、数字、特殊字符长度再9-16位之间
  var regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{9,16}')
  if (value === '') {
    callback(new Error('请输⼊密码'))
  } else if (value.length < 8) {
    callback(new Error('密码最少8位'))
  } else if (!regex.test(value)) {
    callback(new Error('密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位'))
  } else {
    callback()
  }
}
export default {
  name: 'Layout',
  components: {
    TagsView //
  },
  data () {
    return {
      disabled: true,
      editUserFormVisible: false,
      userName: sessionStorage.getItem('userName') || '未登录',
      title: '首页',
      nav: [],
      home: '',
      operation: '',
      system: '',
      largeScreen: '',
      editUserForm: {
        userName: '', mobilePhone: '', passWord: '', passWord1: '', passWord2: ''
      },
      editRules: {
        passWord1: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        passWord2: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      objData: '',
      tipToast: false,
      ws: '',
      timer: '' // 过期时间
    }
  },
  created () {
    this.getNav()
  },
  mounted () {
    console.log(this.ws, 'this.ws')
    this.init()
  },
  // 👇 👇 👇 你全部原有逻辑 100% 还原
  beforeDestroy () {
    if (this.ws) {
      this.ws.close()
    }
    clearInterval(this.timer)
  },
  methods: {
    editUserTap () {
      this.editUserForm.userName = sessionStorage.getItem('userName')
      this.editUserForm.mobilePhone = sessionStorage.getItem('phone')
      this.editUserForm.passWord = sessionStorage.getItem('passwd')
      this.editUserFormVisible = true
    },
    async editUserPassWd (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.editUserForm.passWord1 != this.editUserForm.passWord2 && this.editUserForm.passWord1) {
            this.$message.error('两次密码输入不一致，请重新输入！')
            return false
          }
          const { data: res } = await this.$http.post('userManageServer/user/updateUserPassWord', {
            userName: this.editUserForm.userName,
            mobilePhone: this.editUserForm.mobilePhone,
            passWord: this.editUserForm.passWord1
          })
          if (res.statusCode !== '200') return this.$message.error('修改密码失败')
          this.editUserFormVisible = false
          this.$message.success('修改密码成功,请重新登录')
          setTimeout(() => {
            this.exit()
          }, 2000)
        } else {
          return false
        }
      })
    },
    statusEliminate (str) {
      if (str == '运营管理') {
        this.$route.path != '/operation' ? this.$router.push('/operation') : ''
      } else if (str == '系统管理') {
        this.$route.path != '/system' ? this.$router.push('/system') : ''
      } else if (str == '首页') {
        this.$route.path != '/home' ? this.$router.push('/home') : ''
      }
    },
    toBigscreen () {
      this.$router.push('/bigScreen')
    },
    exit () {
      sessionStorage.clear()
      this.$store.dispatch('CLEAR')
      this.$router.push('/login')
    },
    getNav () {
      this.nav = JSON.parse(sessionStorage.getItem('headerNav'))
      if (this.nav instanceof Array) {
        this.home = this.nav.filter(function (item) {
          return item.menuUrl === '/home'
        })
        this.operation = this.nav.filter(function (item) {
          return item.menuUrl === '/operation'
        })
        this.system = this.nav.filter(function (item) {
          return item.menuUrl === '/system'
        })
        this.largeScreen = this.nav.filter(function (item) {
          return item.menuUrl === '/bigScreen'
        })
      }
      sessionStorage.setItem('menuList', JSON.stringify(this.system[0].twoMenusList))
    },
    // websocket 完整还原
    init () {
      const userId = sessionStorage.getItem('userId')
      if ('WebSocket' in window) {
        this.ws = new WebSocket(process.env.VUE_APP_WS_API + 'pmService/myWs?userId=' + userId)
        this.ws.onopen = this.open
        this.ws.onerror = this.error
        this.ws.onmessage = this.getMessage
        this.ws.onclose = this.close
      } else {
        alert('当前浏览器 Not support websocket')
      }
    },
    open: function () {
      console.log('ws调用连接成功回调方法')
      this.timer = window.setInterval(() => {
        var ping = { type: 'pingpong' }
        this.ws.send(JSON.stringify(ping))
      }, 50000)
    },
    error: function () {
      console.log('WebSocket连接发生错误')
    },
    getMessage (msg) {
      if (msg.data) {
        if (typeof msg.data === 'string') {
          console.log('收到信息:' + msg.data)
          if (msg.data.includes('pingpong')) {
            return false
          }
          const str = JSON.parse(msg.data)
          this.objData = str
          this.tipToast = true
          if (!IsPhone()) {
            handleSpeak(str.title)
          }
          const route = this.$route.path
          if (route === '/operation/dispatch/orderScheduling' || route === '/system/hospitalManagement/Information') {
            if (route === '/system/hospitalManagement/Information') {
              this.$eventBus.$emit('message')
            } else {
              this.$eventBus.$emit('messageOder')
            }
          }
        }
      }
    },
    close: function (e) {
      console.log(e, 'socket已经关闭')
      clearInterval(this.timer)
    },
    playSound () {
      var url = 'http://img.i12320.com/newOrder.mp3'
      var n = new Audio(url)
      n.src = url
      n.play()
    },
    pagenew () {
      if (this.objData.category == 1) {
        this.$router.push('/operation/dispatch/orderScheduling')
      } else {
        this.$router.push('/system/hospitalManagement/Information')
      }
      this.tipToast = false
    }
  }
}
</script>

<style lang="less" scoped>
// 全局布局
.father {
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  .layout-header {
    padding: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    height: auto; /* 取消固定高度，适配内容 */
  }

  // 修复：main区域margin-top，让业务管理页面显示出来
  .main {
    margin-top: 150px !important;
    padding: 0 !important;
    width: 100% !important;
    height: calc(100vh - 120px) !important;
    overflow: auto !important;
  }

  .el-footer {
    padding: 0;
    height: 40px !important;
    line-height: 40px;
    text-align: center;
    background: #f5f5f5;
    font-size: 12px;
    color: #666;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

// 顶部蓝色导航栏
.header-top {
  height: 80px;
  background: url('../../fonts/top_bar_bg.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  color: #fff;
  padding: 0 20px;
  box-sizing: border-box;
	
  .header-left {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      height: 40px;
      width: auto;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
    }
  }

  .header-center {
    flex: 1;
    display: flex;
    // justify-content: center;
	margin-left: 100px;
    gap: 30px;

    > div {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      img {
        height: 20px;
        width: auto;
      }

      span {
        font-size: 20px;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 18px;

    .exit {
      cursor: pointer;
    }
  }
}

// 面包屑+标签页+大屏按钮 区域
.header-under {
  height: 60px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #e6e6e6;
  gap: 15px;
  width: 100%;

  // 面包屑容器
  .breadcrumb-box {
    flex-shrink: 0;
    font-size: 13px;

    .el-breadcrumb__item {
      color: #666;
    }
  }

  // 核心修复：标签页容器加最大宽度，避免挤走大屏按钮
  .tags-view-wrapper {
    flex: 1;
    max-width: calc(100% - 300px); /* 预留面包屑+大屏按钮的宽度 */
    height: 100%;
    overflow: hidden; /* 超出隐藏，只滚动内部标签 */
  }

  // 标签页内部
  .tags-view-inline {
    width: 100%;
    height: 100%;
  }

  // 大屏按钮
  .header-under-btn {
    flex-shrink: 0;
	font-size: 18px;
    height: 32px;
    padding: 0 15px;
    margin-right: 10px;
  }
}
</style>